<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="delall"
                    @print="print"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" v-model="activeName"
                         @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[4586]')" name="0" id="xpane-0">
                        <wTable
                                :data="dataSet"
                                :loading="loading"
                                queryData="ISSProcessOrderViewInfo"
                                :filter_language="['StatusName']"
                                :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                :filter_date="['Plan_date']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:5px"
                        >
                        <el-table-column show-overflow-tooltip prop="IPO_code" :label="$t('getapi[4283]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="StatusName" :label="$t('getapi[2701]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1523]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1344]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Type" :label="$t('getapi[1217]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Cycle" :label="$t('getapi[1600]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Charge" :label="$t('getapi[1646]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Additional_Charge" :label="$t('getapi[6737]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Conditions" :label="$t('getapi[6738]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="contact_person" :label="$t('getapi[6739]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[6740]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_reason" :label="$t('getapi[2337]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_Person" :label="$t('getapi[1634]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[732]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[135]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Date" :label="$t('getapi[1210]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>

                    <el-tab-pane :label="$t('getapi[1422]')" name="1" id="xpane-1">
                        <wTable
                                :data="dataSet1"
                                :loading="loading"
                                queryData="ISSProcessOrderViewInfo"
                                :filter_language="['StatusName']"
                                :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                        ></wTable>
                        <!-- <el-table
                                 :data="dataSet1"
                                 ref="singleTable1"
                                 v-loading="loading"
                                 :highlight-current-row="true"
                                 show-overflow-tooltip="true"
                                 border
                                 stripe
                                 size="mini"
                                 @row-click="editInfo"
                                 @row-dblclick="openEdit"
                                 @selection-change="handleSelectionChange"
                                 :height="tableHeight - reduceTableHeight"
                                 header-row-class-name="headerclass"
                                 style="width: 100%; margin-top:5px"
                         >
                         <el-table-column show-overflow-tooltip prop="IPO_code" :label="$t('getapi[4283]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="StatusName" :label="$t('getapi[2701]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1523]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1344]')" align="right"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Trans_Type" :label="$t('getapi[1217]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Pay_Cycle" :label="$t('getapi[1600]')" align="right"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Trans_Charge" :label="$t('getapi[1646]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Additional_Charge" label="附加费"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Pay_Conditions" label="付款条件"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="contact_person" label="发货至联系人"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="transact_person" label="经办人"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Shut_reason" :label="$t('getapi[2337]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Shut_Person" :label="$t('getapi[1634]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[732]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[135]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                         <el-table-column show-overflow-tooltip prop="Modify_Date" :label="$t('getapi[1210]')"></el-table-column>
                         </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6094]')" name="7">
                        <el-tabs :tab-position="'top'" type="" style="margin-top: 5px" v-model="activeName1"
                                 @tab-click="selectInfo7">
                            <el-tab-pane :label="$t('getapi[945]')" name="7_1">
                                <wTable
                                        id="xpane-7_1"
                                        :data="dataSet7"
                                        :loading="loading"
                                        queryData="ISSProcessOrderViewInfo"
                                        :filter_language="['StatusName']"
                                        :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                        :header="tableHeader"
                                        :option="tableOption1"
                                        @edits="editInfo"
                                        @rowdblclick="openEdit"
                                        ref="singleTable7_1"
                                        :checkflg="false"
                                ></wTable>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[6362]')" name="7_2">
                                <el-button type="primary" size="mini" :disabled="selectData.length == 0" @click="batchAudit" v-if="activeName == 7 && activeName1=='7_2'">{{$t('getapi[1315]')}}</el-button>
                                <wTable
                                        id="xpane-7_2"
                                        :data="dataSet7_2"
                                        :loading="loading"
                                        queryData="ISSProcessOrderViewInfo"
                                        :filter_language="['StatusName']"
                                        :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                        :header="tableHeader"
                                        :option="tableOption2"
                                        @edits="editInfo"
                                        @rowdblclick="openEdit"
                                        ref="singleTable7_2"
                                        @handleSelectionChange="handlelistSelectionChange"
                                ></wTable>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>

                    <el-tab-pane :label="$t('getapi[6095]')" name="2" id="xpane-2">
                        <wTable
                                :data="dataSet2"
                                :loading="loading"
                                queryData="ISSProcessOrderViewInfo"
                                :filter_language="['StatusName']"
                                :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:5px"
                        >
                        <el-table-column show-overflow-tooltip prop="IPO_code" :label="$t('getapi[4283]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="StatusName" :label="$t('getapi[2701]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1523]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1344]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Type" :label="$t('getapi[1217]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Cycle" :label="$t('getapi[1600]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Charge" :label="$t('getapi[1646]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Additional_Charge" :label="$t('getapi[6737]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Conditions" :label="$t('getapi[6738]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="contact_person" :label="$t('getapi[6739]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[6740]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_reason" :label="$t('getapi[2337]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_Person" :label="$t('getapi[1634]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[732]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[135]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Date" :label="$t('getapi[1210]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>

                    <el-tab-pane :label="$t('getapi[1621]')" name="3" id="xpane-3">
                        <wTable
                                :data="dataSet3"
                                :loading="loading"
                                queryData="ISSProcessOrderViewInfo"
                                :filter_language="['StatusName']"
                                :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable3"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet3"
                                ref="singleTable3"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:5px"
                        >
                        <el-table-column show-overflow-tooltip prop="IPO_code" :label="$t('getapi[4283]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="StatusName" :label="$t('getapi[2701]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1523]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1344]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Type" :label="$t('getapi[1217]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Cycle" :label="$t('getapi[1600]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Charge" :label="$t('getapi[1646]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Additional_Charge" :label="$t('getapi[6737]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Conditions" :label="$t('getapi[6738]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="contact_person" :label="$t('getapi[6739]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[6740]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_reason" :label="$t('getapi[2337]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_Person" :label="$t('getapi[1634]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[732]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[135]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Date" :label="$t('getapi[1210]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>

                    <el-tab-pane :label="$t('getapi[1622]')" name="4" id="xpane-4">
                        <wTable
                                :data="dataSet4"
                                :loading="loading"
                                queryData="ISSProcessOrderViewInfo"
                                :filter_language="['StatusName']"
                                :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable4"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet4"
                                ref="singleTable4"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:5px"
                        >
                        <el-table-column show-overflow-tooltip prop="IPO_code" :label="$t('getapi[4283]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="StatusName" :label="$t('getapi[2701]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1523]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1344]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Type" :label="$t('getapi[1217]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Cycle" :label="$t('getapi[1600]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Charge" :label="$t('getapi[1646]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Additional_Charge" :label="$t('getapi[6737]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Conditions" :label="$t('getapi[6738]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="contact_person" :label="$t('getapi[6739]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[6740]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_reason" :label="$t('getapi[2337]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_Person" :label="$t('getapi[1634]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[732]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[135]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Date" :label="$t('getapi[1210]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>

                    <el-tab-pane :label="$t('getapi[6097]')" name="5" id="xpane-5">
                        <wTable
                                :data="dataSet5"
                                :loading="loading"
                                queryData="ISSProcessOrderViewInfo"
                                :filter_language="['StatusName']"
                                :filter_thousandth="['Pay_Cycle','Trans_Charge','Additional_Charge','line_total_amount','line_net_amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable5"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet5"
                                ref="singleTable5"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:5px"
                        >
                        <el-table-column show-overflow-tooltip prop="IPO_code" :label="$t('getapi[4283]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="StatusName" :label="$t('getapi[2701]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1523]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1344]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Type" :label="$t('getapi[1217]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Cycle" :label="$t('getapi[1600]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Trans_Charge" :label="$t('getapi[1646]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Additional_Charge" :label="$t('getapi[6737]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pay_Conditions" :label="$t('getapi[6738]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Plan_date" :label="$t('getapi[1601]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="contact_person" :label="$t('getapi[6739]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[6740]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_reason" :label="$t('getapi[2337]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Shut_Person" :label="$t('getapi[1634]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[732]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[135]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_Date" :label="$t('getapi[1210]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>

                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="DownOrder" :disabled="!btn.assign">
                            {{$t('getapi[1488]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="CancelDownOrder" :disabled="!btn.cancelassign">
                            {{$t('getapi[6741]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="CloseOrder" :disabled="!btn.confirmclose">
                            {{$t('getapi[2763]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="unAudit" :disabled="dataDetail.approvalstatus != 1">
                            {{$t('getapi[8507]')}}
                        </el-button>
                    </div>
                    <div style="width:900px;min-width:900px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px"><span>{{$t('getapi[3565]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.IPO_code"
                                              :readonly="!IsEditCode" :class="{'readO':!IsEditCode}"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px"><span>{{$t('getapi[410]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Create_Person"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px"><span>{{$t('getapi[135]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Create_Date"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px"><span>{{$t('getapi[552]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" :value="expStatus(dataDetail.Order_Status)"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px"><span>{{$t('getapi[1227]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Currency_Code"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{$t('getapi[6024]')}}</span></td>
                                <td><el-input type="text" size="mini" :value="expFinanceStatus(dataDetail.approvalstatus)"
                                              :readonly="true" class="readO"></el-input></td>
                                <td><span>{{$t('getapi[1287]')}}</span></td>
                                <td><el-input type="text" size="mini" v-model="dataDetail.Vender_Code"
                                              :readonly="true" class="readO"></el-input></td>
                                <td><span>{{$t('getapi[1197]')}}</span></td>
                                <td colspan="3"><el-input type="text" size="mini" v-model="dataDetail.Vender_Name"
                                                          :readonly="true" class="readO"></el-input></td>
                                <td><span style="min-width:30px">{{$t('getapi[1225]')}}</span></td>
                                <td><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width:110px;"
                                              v-model="dataDetail.Tax_Rate" :readonly="true" class="readO"></el-input>
                                    %</td>
                            </tr>
                            <tr>
                                <td><span>{{$t('getapi[1601]')}}</span></td>
                                <td colspan="2">
                                    <el-date-picker
                                            v-model="dataDetail.Plan_date"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%;"
                                            class="mcolor"
                                            size="mini"
                                            :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"
                                    ></el-date-picker>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!--<div class="box" style="height: 70px;margin-top:5px">
                        <div class="bbl">
                            <span>{{$t('getapi[3565]')}}</span>
                            <el-input type="text" size="mini" style="width: 100px;" v-model="dataDetail.IPO_code"
                                      :readonly="!IsEditCode" :class="{'readO':!IsEditCode}"></el-input>
                            <span>{{$t('getapi[410]')}}</span>
                            <el-input type="text" size="mini" style="width: 100px;" v-model="dataDetail.Create_Person"
                                      :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[135]')}}</span>
                            <el-input type="text" size="mini" style="width: 100px;" v-model="dataDetail.Create_Date"
                                      :readonly="true" class="readO"></el-input>
                            <span style="min-width:30px">{{$t('getapi[552]')}}</span>
                            <el-input type="text" size="mini" style="width: 80px;" :value="expStatus(dataDetail.Order_Status)"
                                      :readonly="true" class="readO"></el-input>&nbsp;
                            <span>{{$t('getapi[1227]')}}</span>
                            <el-input type="text" size="mini" style="width: 100px;" v-model="dataDetail.Currency_Code"
                                      :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[6024]')}}</span>
                            <el-input type="text" size="mini" style="width: 100px;" :value="expFinanceStatus(dataDetail.approvalstatus)"
                                      :readonly="true" class="readO"></el-input>
                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[1287]')}}</span>
                            <el-input type="text" size="mini" style="width: 100px;" v-model="dataDetail.Vender_Code"
                                      :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[1197]')}}</span>
                            <el-input type="text" size="mini" style="width: 280px;" v-model="dataDetail.Vender_Name"
                                      :readonly="true" class="readO"></el-input>
                            <span style="min-width:30px">{{$t('getapi[1225]')}}</span>
                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 72px;"
                                      v-model="dataDetail.Tax_Rate" :readonly="true" class="readO"></el-input>
                            %
                            <span>{{$t('getapi[1601]')}}</span>
                            <el-date-picker
                                    v-model="dataDetail.Plan_date"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100px;"
                                    class="mcolor"
                                    size="mini"
                            ></el-date-picker>
                        </div>
                    </div>-->
                    <el-tabs :tab-position="'top'" style="margin-top: 5px" @tab-click="selectInfo1">
                        <el-tab-pane :label="$t('getapi[1625]')" name="0">
                            <div class="btnnowrap">
                                <el-button type="primary" size="mini" icon="el-icon-delete-solid" @click="delline"
                                           :disabled="!btn.deleteline">{{$t('getapi[3886]')}}
                                </el-button>
                                <el-button type="primary" size="mini" icon="el-icon-delete-solid" @click="mustclose"
                                           :disabled="!btn.mustclose">{{$t('getapi[6742]')}}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.DTlines"
                                    ref="singleTable8"
                                    v-loading="dloading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    :row-class-name="tableRowClassNameM"
                                    @selection-change="handleSelectionChangeM"
                                    :height="tableHeight - 200"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:3px"
                                    @sort-change="sortChange"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip width='50' prop="Line_No"
                                                 :label="$t('getapi[1425]')" sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip width='130' prop="Part_Code"
                                                 :label="$t('getapi[112]')" sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[149]')"
                                                 sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Part_Name" :label="$t('getapi[116]')"
                                                 sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="LineStatusName" :label="$t('getapi[552]')"
                                                 sortable="custom">
                                    <template scope="scope">
                                        <span>{{ scope.row.LineStatusName | lanchange}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="line_total_unitprice"
                                                 :label="$t('getapi[1302]')" sortable="custom">
                                    <template slot-scope="scope">
                                        {{scope.row.line_total_unitprice | cutZero}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="line_net_unitprice"
                                                 :label="$t('getapi[1303]')" sortable="custom">
                                    <template slot-scope="scope">
                                        {{scope.row.line_net_unitprice | cutZero}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="line_total_amount"
                                                 :label="$t('getapi[1598]')" sortable="custom">
                                    <template slot-scope="scope">
                                        {{scope.row.line_total_amount | cutZero}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="line_net_amount"
                                                 :label="$t('getapi[1599]')" sortable="custom">
                                    <template slot-scope="scope">
                                        {{scope.row.line_net_amount | cutZero}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="line_total_amount_cny"
                                                 :label="$t('getapi[6743]')" sortable="custom">
                                    <template slot-scope="scope">
                                        {{scope.row.line_total_amount_cny | cutZero}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="line_net_amount_cny"
                                                 :label="$t('getapi[6744]')" sortable="custom">
                                    <template slot-scope="scope">
                                        {{scope.row.line_net_amount_cny | cutZero}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="Line_Qty"
                                                 :label="$t('getapi[3101]')" sortable="custom">
                                    <template slot-scope="scope">
                                        <el-input  v-if="dataDetail.Order_Status == 0" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Line_Qty"
                                                  @blur="detailSum(scope)"
                                                  @focus="$refs.SetBtn.SetOneBtnEnable('save', false)"></el-input>
                                        <span v-if="dataDetail.Order_Status != 0">{{scope.row.Line_Qty}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="Measure_Unit" :label="$t('getapi[888]')"
                                                 sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="RoutingStartName"
                                                 :label="$t('getapi[6699]')" sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="SO_Code" :label="$t('getapi[6745]')"
                                                 sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Routing_Sequence_No"
                                                 :label="$t('getapi[4286]')" sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="IsFirstVender" :label="$t('getapi[1615]')"
                                                 sortable="custom">
                                    <template slot-scope="scope">
                                        <el-checkbox true-label='True' false-label="False"
                                                     v-model="scope.row.IsFirstVender"
                                                     :checked="scope.row.IsFirstVender=='True'?true:false"
                                                     :disabled="true"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="Plan_Delivery_Date"
                                                 :label="$t('getapi[1601]')" sortable="custom">
                                    <template slot-scope="scope">
                                        <el-input v-if="dataDetail.Order_Status != 5" type="text" v-model="scope.row.Plan_Delivery_Date"></el-input>
                                        <span v-if="dataDetail.Order_Status == 5">{{scope.row.Plan_Delivery_Date}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="Actual_Delivery_Date"
                                                 :label="$t('getapi[2705]')" sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Process_Remark" :label="$t('getapi[6702]')"
                                                 sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Line_Remark" :label="$t('getapi[143]')"
                                                 sortable="custom">
                                    <template slot-scope="scope">
                                        <el-input type="text" v-model="scope.row.Line_Remark"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="Schedule_No" :label="$t('getapi[4209]')"
                                                 sortable="custom"></el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="lose_qty"
                                                 :label="$t('getapi[6746]')" sortable="custom"></el-table-column>
                                <el-table-column show-footer-overflow prop="ce_flag" :label="$t('getapi[8047]')"
                                                 sortable="custom" width="50">
                                    <template slot-scope="scope">
                                        <el-checkbox size="mini" v-model="scope.row.ce_flag" :true-label=1
                                                     :false-label=0 :disabled="true" sortable="custom"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column show-footer-overflow prop="Item_Code" :label="$t('getapi[3367]')"
                                                 sortable="custom" width="100">
                                </el-table-column>
                                <el-table-column show-overflow-tooltip width="50"></el-table-column>
                            </el-table>
                            <div class="box" style="height: 50px;margin-top:5px">
                                <div class="bbl">
                                    <span>{{$t('getapi[6747]')}}</span>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;"
                                              :value="orderAPrice | cutZero" :readonly="true" class="readO"></el-input>
                                    <span style="margin-right:10px">{{$t('getapi[6748]')}}</span>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;"
                                              :value="orderBPrice | cutZero" :readonly="true" class="readO"></el-input>
                                    <span style="margin-right:10px">{{$t('getapi[6749]')}}</span>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;"
                                              :value="orderCPrice | cutZero" :readonly="true" class="readO"></el-input>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6750]')" name="1">
                            <div style="width:600px;min-width:600px">
                                <table>
                                    <tr>
                                        <td style="width:80px;min-width:80px"><span>{{$t('getapi[1217]')}}</span></td>
                                        <td style="width:120px;min-width:120px">
                                            <el-select filterable popper-class="select-option"
                                                       v-model="dataDetail.Trans_Type"
                                                       size="mini"
                                            :disabled="dataDetail.Order_Status == 5">
                                                <el-option v-for="item in TransList"
                                                           :key="item.Code"
                                                           :label="item.Name"
                                                           :value="item.Name"></el-option>
                                            </el-select>
                                        </td>
                                        <td style="width:80px;min-width:80px"><span>{{$t('getapi[1600]')}}</span></td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 110px;"
                                                      v-model="dataDetail.Pay_Cycle"
                                                      :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"></el-input>
                                            {{$t('getapi[217]')}}
                                        </td>
                                        <td style="width:80px;min-width:80px"><span>{{$t('getapi[1646]')}}</span></td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                      @dblclick.native="selectRouting"
                                                      v-model="dataDetail.Trans_Charge"
                                                      :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[6740]')}}</span></td>
                                        <td><el-input type="text" size="mini"
                                                      v-model="dataDetail.Transact_person"
                                                      @dblclick.native="selectpeople"
                                                      :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"></el-input></td>
                                        <td><span>{{$t('getapi[6739]')}}</span></td>
                                        <td><el-input type="text" size="mini"
                                                      v-model="dataDetail.Contact_person"
                                                      :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"></el-input></td>
                                        <td><span>{{$t('getapi[6737]')}}</span></td>
                                        <td><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                      v-model="dataDetail.Additional_Charge"
                                                      :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[1116]')}}</span></td>
                                        <td colspan="5"><el-input type="textarea" size="mini"
                                                                  v-model="dataDetail.Pay_Conditions" @input="CalTaxPrice"
                                                                  :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[1633]')}}</span></td>
                                        <td colspan="3"><el-input type="textarea" size="mini"
                                                                  v-model="dataDetail.Shut_reason"
                                                                  :readonly="dataDetail.Order_Status == 5" :class="{'readO':dataDetail.Order_Status == 5}"></el-input></td>
                                        <td><span>{{$t('getapi[2356]')}}</span></td>
                                        <td><el-input type="text" size="mini"
                                                      v-model="dataDetail.Shut_Person" :readonly="true" class="readO"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td><span>{{$t('getapi[143]')}}</span></td>
                                        <td colspan="5"><el-input type="textarea" v-model="dataDetail.Remark"
                                                      size="mini"></el-input></td>
                                    </tr>
                                </table>
                            </div>
                            <!--<div class="box" style="height: 300px;margin-top:0px">
                                <div class="bbl">
                                    <span>{{$t('getapi[1217]')}}</span>
                                    <el-select filterable popper-class="select-option" style="width: 130px;"
                                               v-model="dataDetail.Trans_Type"
                                               size="mini">
                                        <el-option v-for="item in TransList"
                                                   :key="item.Code"
                                                   :label="item.Name"
                                                   :value="item.Name"></el-option>
                                    </el-select>


                                    <span>{{$t('getapi[1600]')}}</span>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 118px;"
                                              v-model="dataDetail.Pay_Cycle"></el-input>
                                    {{$t('getapi[217]')}}
                                    <span>{{$t('getapi[1646]')}}</span>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;"
                                              @dblclick.native="selectRouting"
                                              v-model="dataDetail.Trans_Charge"></el-input>

                                </div>
                                <div class="bbl">
                                    <span>{{$t('getapi[6740]')}}</span>
                                    <el-input type="text" size="mini" style="width: 130px;"
                                              v-model="dataDetail.Transact_person"
                                              @dblclick.native="selectpeople"></el-input>
                                    <span>{{$t('getapi[6739]')}}</span>
                                    <el-input type="text" size="mini" style="width: 130px;"
                                              v-model="dataDetail.Contact_person"></el-input>
                                    <span>{{$t('getapi[6737]')}}</span>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 130px;"
                                              v-model="dataDetail.Additional_Charge"></el-input>
                                </div>
                                <div class="bbl">
                                    <span>{{$t('getapi[1116]')}}</span>
                                    <el-input type="textarea" size="mini" style="width: 570px;"
                                              v-model="dataDetail.Pay_Conditions" @input="CalTaxPrice"></el-input>
                                </div>
                                <div class="bbl">
                                    <span>{{$t('getapi[1633]')}}</span>
                                    <el-input type="textarea" size="mini" style="width: 350px;"
                                              v-model="dataDetail.Shut_reason"></el-input>
                                    <span>{{$t('getapi[2356]')}}</span>
                                    <el-input type="text" size="mini" style="width: 130px;"
                                              v-model="dataDetail.Shut_Person" :readonly="true" class="readO"></el-input>

                                </div>
                                <div class="bbl">
                                    <span>{{$t('getapi[143]')}}</span>
                                    <el-input type="textarea" v-model="dataDetail.Remark" style="width:570px;"
                                              size="mini"></el-input>
                                </div>
                            </div>-->
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6751]')" name="2">
                            <el-table
                                    id="xdetilpane-2"
                                    :data="dataDetail.DTlinesMaterial"
                                    ref="detailTable"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    :height="tableHeight - 200"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:5px"
                            >
                                <el-table-column show-overflow-tooltip width='130' prop="SO_Code"
                                                 :label="$t('getapi[6745]')"></el-table-column>
                                <el-table-column show-overflow-tooltip width='80' prop="Routing_Sequence_No"
                                                 :label="$t('getapi[4286]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Part_Code"
                                                 :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip width='80' prop="Part_Version"
                                                 :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Part_Name"
                                                 :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="WorkProc_Name"
                                                 :label="$t('getapi[4364]')"></el-table-column>
                                <el-table-column show-overflow-tooltip align='right' prop="Issue_Total_Qty"
                                                 :label="$t('getapi[6752]')" width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.Issue_Total_Qty"
                                                  v-if="scope.row.Workproc_ID == 0 && dataDetail.Status_Name == '下达'"></el-input>
                                        <span v-if="scope.row.Workproc_ID != 0 || dataDetail.Status_Name != '下达'">{{scope.row.Issue_Total_Qty}}</span>
                                    </template>
                                </el-table-column>

                            </el-table>

                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6101]')" name="3" v-if="dataDetail.AuditInfoLists.length != 0">
                            <el-button type="primary" size="mini" @click="selectAuditer"
                                       :disabled="!btn.canEditAuditPerson">{{ $t('getapi[438]')
                                }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="delAuditer"
                                       :disabled="!btn.canEditAuditPerson">{{ $t('getapi[656]')
                                }}
                            </el-button>
                            <el-table :data="dataDetail.AuditInfoLists" :height="tableHeight - 260" size="mini"
                                      style="width: 100%; margin-top:2px"
                                      header-row-class-name="headerclass"
                                      :header-cell-style="$limits.headerClass"
                                      :row-class-name="tableRowClassNameAudit"
                                      @selection-change="handleSelectionChangeAudit">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Line_No"
                                                 :label="$t('getapi[1297]')">
                                    <template scope="scope">
                                        <el-input size="mini" v-model="scope.row.Line_No"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="AuditPerson"
                                                 :label="$t('getapi[6039]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Post_Name"
                                                 :label="$t('getapi[3180]')">
                                    <template scope="scope">
                                        <el-input size="mini" v-model="scope.row.Post_Name"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="Approval_Opinion"
                                                 :label="$t('getapi[6103]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="approval_resultsname"
                                                 :label="$t('getapi[6102]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Modify_time"
                                                 :label="$t('getapi[4044]')"></el-table-column>
                                <el-table-column fixed="right" :label="$t('getapi[6048]')" width="100">
                                    <template scope="scope">
                                        <el-button @click.native.prevent="addAuditer(scope.row)" type="text"
                                                   size="small"
                                                   v-if="scope.row.Exclusively_ID == ''">
                                            {{ $t('getapi[878]') }}
                                        </el-button>
                                        <el-button @click.native.prevent="sign(scope.row)" type="text" size="small"
                                                   v-if="scope.row.isCanAudit && scope.row.AuditPerson == user">
                                            {{ $t('getapi[6101]') }}
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 3">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange3"
                        @current-change="handleCurrentChange3"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize3"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total3"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 4">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange4"
                        @current-change="handleCurrentChange4"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize4"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total4"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 5">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange5"
                        @current-change="handleCurrentChange5"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize5"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total5"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 7">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange7"
                        @current-change="handleCurrentChange7"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize7"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total7"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ISSProcessOrderViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1039]')" queryData="ISSProcessOrderViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择供应商编码-->
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetSupplyPopuDataList'" @callback="getsupplier" ref="supplier"></selector>
        <!--选择物料编码-->
        <selector :isVisible="false" :selectType="11" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
        <!--委外选择物料编码-->
        <selector :isVisible="false" :selectType="12" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpartt" ref="partt"></selector>
        <!--选择外协工序-->
        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getPeople" ref="people"></selector>
        <!--添加审核人-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=true :selectType="1"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getAuditer" ref="auditer"></selector>

        <el-dialog v-dialogDrag :visible.sync="signVisiable" width="40%" :close-on-click-modal="false">
            <div>
                <el-input v-model="reason" type="textarea" size="mini"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="signVisiable = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmSign(0)">{{$t('getapi[6188]')}}</el-button>
				<el-button type="primary" @click="confirmSign(1)">{{$t('getapi[6187]')}}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="signVisiableBatch" width="40%" :close-on-click-modal="false">
            <div>
                <el-input v-model="reason" type="textarea" size="mini"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="signVisiableBatch = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmBatchAudit(0)">{{$t('getapi[6188]')}}</el-button>
				<el-button type="primary" @click="confirmBatchAudit(1)">{{$t('getapi[6187]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';
    import {Loading} from 'element-ui';

    export default {
        name: 'wxorder',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableOption1() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2-30,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2-30,
                }
            },
            tableOption2() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2-40,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2-40,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                IsEditCode: false,
                visReplacePart: false,
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('wxorder'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                oldSelectIndex: 0,
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('wxorder1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('wxorder2'), // 当前页数据量
                total2: 0, // 数据总量
                dataSet3: [], // 主表数据
                pageIndex3: 1, // 当前页
                pageSize3: this.$http.getPageSize('wxorder3'), // 当前页数据量
                total3: 0, // 数据总量
                dataSet4: [], // 主表数据
                pageIndex4: 1, // 当前页
                pageSize4: this.$http.getPageSize('wxorder4'), // 当前页数据量
                total4: 0, // 数据总量

                dataSet5: [], // 主表数据
                pageIndex5: 1, // 当前页
                pageSize5: this.$http.getPageSize('wxorder5'), // 当前页数据量
                total5: 0, // 数据总量
                dataSet7: [], // 主表数据
                pageIndex7: 1, // 当前页
                pageSize7: this.$http.getPageSize('wxorder7'), // 当前页数据量
                total7: 0, // 数据总量
                dataSet7_2: [],
                loading: false, // 主表加载状态
                dloading: false,//此表加载状态
                IsEditPrice: false,//是否可以编辑不含税单价
                RStartName: '',//前端缓存外协工序名
                reduceTableHeight: Common.reduceTableHeight2,
                dataDetail: {
                    DTlines: [],
                    DTlinesMaterial:[],
                    AuditInfoLists:[],
                    IPO_code: "",
                    IsEdit: 0,
                    huilv: 1,
                    Vender_Code: "",
                    Vender_Name: "",
                    Currency_Code: "CNY",
                    Tax_Rate: 0,
                    Order_Status: 0,
                    Status_Name: "生成",
                    Trans_Type: "",
                    Pay_Cycle: 0,
                    Trans_Charge: 0,
                    Additional_Charge: 0,
                    Pay_Conditions: "",
                    Plan_date: "",
                    Contact_person: "",
                    Transact_person: "",
                    Shut_reason: "",
                    Shut_Person: "",
                    Audit_Person: "",
                    Audit_Date: "",
                    Remark: "",
                    Create_Person: "",
                    Create_Date: "",
                    Modify_Person: "",
                    Modify_Date: "",
                    Vender_Call: "",
                    Vender_Fax: "",
                    Approval_statusName:""
                },
                oldDataDetail: '',
                SignList: [],
                TransList: [],//运输方式
                multipleSelection: [],//左侧主表选择
                multipleSelectionMain: [],
                selectData1: [],
                selectData2: [],
                selectData3: [],
                selectData4: [],
                selectDataAudit: [],
                btn: {
                    deleteline: false,
                    mustclose: false,//强制关闭
                    assign: false,
                    cancelassign: false,
                    confirmclose: false,
                    canEditAuditPerson: false,
                },
                srType: [],//sr类别
                orderDetail: {
                    plancode: '',
                    issrso: '0',
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                },
                visOrder: false,
                otherobj: [],//来源跳转页面
                paramobj: [{}],
                orderType: 1,
                orderAPrice: 0,//订单税额
                orderBPrice: 0,//订单不含税额
                orderCPrice: 0,//订单含税额  A+B=C
                activeName: 0,
                activeName1: '7_1',
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                RightSelectIndex: '0',
                signVisiable: false,
                reason: '',
                selectSignData: [], // 审批详情选中行
                selectData:[],
                signVisiableBatch: false,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
                scrollTop5:0,
                scrollTop6:0,
                scrollTop7_1:0,
                scrollTop7_2:0,
                scrollTop8:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet3: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet4: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet5: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet7: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm('7_1')
                })
            },
            dataSet7_2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm('7_2')
                })
            },
            dataDetail: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
                that.$refs.singleTable5.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop5 = res.target.scrollTop
                },false)
                that.$refs.singleTable6.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop6 = res.target.scrollTop
                },false)
                that.$refs.singleTable7_1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop7_1 = res.target.scrollTop
                },false)
                that.$refs.singleTable7_2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop7_2 = res.target.scrollTop
                },false)
                that.$refs.singleTable8.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop8 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop4;
                    this.$refs.singleTable5.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop5;
                    this.$refs.singleTable6.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop6;
                    this.$refs.singleTable7_1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop7_1;
                    this.$refs.singleTable7_2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop7_2;
                    this.$refs.singleTable8.bodyWrapper.scrollTop =this.scrollTop8;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('wxorder', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            //that.dataDetail.Trans_Type
            that.$limits.dragControllerDiv();
            that.confirmAdd()

        },
        created: function () {
            this.TransList = Array.methods.getTransMode();
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'wxplantrans' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    let id = to.params.id;
                    vm.lineytpes = id;
                    const data = {...vm.$store.state.sharedParams};
                    vm.otherobj = data;
                    vm.intidata();
                    setTimeout(() => {
                        vm.openEdit()
                    }, 1000);
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'issrelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'prorelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ISSProcessOrderViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            intidata() {
                let that = this;
                if (that.$limits.fnIsEmpty(that.otherobj)) return;
                that.confirmAdd();
                let param = [{}];
                for (var i in that.otherobj) {
                    that.otherobj[i].LangType = that.$processdata.getLang(),
                    that.$set(param, i, that.otherobj[i]);
                }
                if (param[0].so_code) {
                    that.paramobj = param;//缓存
                } else {
                    param = that.paramobj;//拿上一次的
                }
                //let parm=[];
                that.dloading = true;
                that.$http.urlpost('/ISS/Order/CreateISSOrder', param, function (res) {
                    if (res.Success == 1) {
                        //清空左边
                        that.dataSet = [];
                       that.dataDetail = res.DataContent;
                        that.dataDetail.Status_Name = '生成';
                        that.dataDetail.IPO_code = '';
                        that.dataDetail.IsEdit = 0;
                        that.IsEditCode = true;
                        for (let i = 0; i < that.dataDetail.DTlines.length; i++) {
                            that.dataDetail.DTlines[i].Part_Version = that.dataDetail.DTlines[i].part_version;
                            that.dataDetail.DTlines[i].LineStatusName = '生成';
                            if (that.dataDetail.DTlines[i].IsFirstVender == "False") that.dataDetail.DTlines[i].IsFirstVender = false;
                            else that.dataDetail.DTlines[i].IsFirstVender = true;
                        }
                        that.caculateTax();
                        that.dloading = false;
                        that.authority();
                        that.btnauthority()
                    }
                });
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1039]"),this.$t("getapi[13]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (!this.$limits.menuvisible("plv2", 131, 1)) {
                    var value = that.$limits.newOperationAuthorityView('plv2', 130, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    //that.$refs.SetBtn.SetButtonEnable('export');
                    if (that.$limits.authority('plv2', 131, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 131, 1) == 2) {
                        if (that.$limits.authority('plv3', 131, 1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 131, 1) == 1) {

                            //编辑级
                            if (that.$limits.fnIsEmpty(that.dataDetail.IPO_code)) {
                                that.$refs.SetBtn.SetButtonEnable('search,save,refresh,export');
                            }
                            else {
                                that.$refs.SetBtn.SetButtonEnable('search,save,refresh,print,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 131, 1) == 2) {
                            //删除级
                            if (that.$limits.fnIsEmpty(that.dataDetail.IPO_code)) {
                                that.$refs.SetBtn.SetButtonEnable('search,save,refresh,export');
                            }
                            else {
                                if (that.dataDetail.Order_Status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('search,save,refresh,print,export');
                                }
                                else {
                                    if (that.dataDetail.Order_Status == 5) {
                                        that.$refs.SetBtn.SetButtonEnable('');
                                    }
                                    else {
                                        if (that.dataDetail.Order_Status == 0) {
                                            that.$refs.SetBtn.SetButtonEnable('search,save,del,refresh,export');
                                        } else {
                                            that.$refs.SetBtn.SetButtonEnable('search,save,del,refresh,print,export');
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if(that.dataDetail.Order_Status ==5){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.deleteline = false;
                that.btn.mustclose = false;
                that.btn.assign = false;
                that.btn.cancelassign = false;
                that.btn.confirmclose = false;
                that.btn.canEditAuditPerson = true;
                for (let i = 0; i < that.dataDetail.AuditInfoLists.length; i++) {
                    if (that.dataDetail.AuditInfoLists[i].Approval_Results != 2) {
                        that.btn.canEditAuditPerson = false;
                        continue
                    }
                }
                if (that.dataDetail.Status_Name == '生成') {
                    that.btn.deleteline = true;
                    that.btn.mustclose = true;
                    if (that.$limits.authority('plv4', 71, 1) == 1) {
                        that.btn.assign = true;
                    } else {
                        that.btn.assign = false
                    }
                    that.btn.cancelassign = false;
                    that.btn.confirmclose = false;
                } else if (that.dataDetail.Status_Name == '下达') {
                    that.btn.deleteline = true;
                    that.btn.mustclose = true;
                    that.btn.assign = false;
                    if (that.$limits.authority('plv4', 71, 1) == 1) {
                        that.btn.cancelassign = true;
                    } else {
                        that.btn.cancelassign = false;
                    }
                    if (that.$limits.authority('plv4', 72, 1) == 1) {
                        that.btn.confirmclose = true;
                    } else {
                        that.btn.confirmclose = false;
                    }
                } else if (that.dataDetail.Status_Name == '部分到达') {
                    that.btn.deleteline = false;
                    that.btn.mustclose = true;
                    that.btn.assign = false;
                    that.btn.cancelassign = false;
                    if (that.$limits.authority('plv4', 72, 1) == 1) {
                        that.btn.confirmclose = true;
                    } else {
                        that.btn.confirmclose = false;
                    }
                } else if (that.dataDetail.Status_Name == '到达') {
                    that.btn.deleteline = false;
                    that.btn.mustclose = true;
                    that.btn.assign = false;
                    that.btn.cancelassign = false;
                    if (that.$limits.authority('plv4', 72, 1) == 1) {
                        that.btn.confirmclose = true;
                    } else {
                        that.btn.confirmclose = false;
                    }
                } else if (that.dataDetail.Status_Name == '关闭') {
                    that.btn.deleteline = false;
                    that.btn.mustclose = false;
                    that.btn.assign = false;
                    that.btn.cancelassign = false;
                    that.btn.confirmclose = false;
                }
                if (that.multipleSelectionMain.length > 0) {
                    that.btn.mustclose = true;
                    if (that.dataDetail.Status_Name == '生成') that.btn.deleteline = true;
                    else that.btn.deleteline = false;
                } else {
                    that.btn.mustclose = false;

                    that.btn.deleteline = false;

                }

            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if (!that.iscontinuedblclick) {
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('wxorder', val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('wxorder1', val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('wxorder2', val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            handleSizeChange3(val) {
                this.pageSize3 = val;
                this.$http.savePageSize('wxorder3', val)
                this.getView();
            },
            handleCurrentChange3(val) {
                this.pageIndex3 = val;
                this.getView();
            },
            handleSizeChange4(val) {
                this.pageSize4 = val;
                this.$http.savePageSize('wxorder4', val)
                this.getView();
            },
            handleCurrentChange4(val) {
                this.pageIndex4 = val;
                this.getView();
            },
            handleSizeChange5(val) {
                this.pageSize5 = val;
                this.$http.savePageSize('wxorder5', val)
                this.getView();
            },
            handleCurrentChange5(val) {
                this.pageIndex5 = val;
                this.getView();
            },
            handleSizeChange7(val) {
                this.pageSize7 = val;
                this.$http.savePageSize('wxorder7', val)
                this.getView();
            },
            handleCurrentChange7(val) {
                this.pageIndex7 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.activeName = tab.name;
                that.getView();
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            selectInfo7(tab, event) {
                let that = this;
                that.SelectIndex = 7;
                that.activeName1 = tab.name
                that.getView();
                that.$nextTick(function () {
                    that.$processdata.initForm(tab.name)
                });
            },
            selectInfo1(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function () {
                    that.$processdata.initForm(that.RightSelectIndex)
                });
            },
            //下达
            DownOrder() {
                let that = this;
                let parm = {
                    code: that.dataDetail.IPO_code,
                    ids: "",
                    update_time: that.dataDetail.Modify_Date,
                    LangType: that.$processdata.getLang()
                }
                that.btn.assign = false;
                that.$http.urlpost('/ISS/Order/ExeAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[4134]'));//'下达成功'
                        that.getDetail(that.dataDetail.IPO_code)
                    }
                });

            },
            //取消下达
            CancelDownOrder() {
                let that = this;

                let parm = {
                    code: that.dataDetail.IPO_code,
                    ids: "",
                    update_time: that.dataDetail.Modify_Date,
                    LangType: that.$processdata.getLang()
                }
                that.btn.cancelassign = false;
                that.$http.urlpost('/ISS/Order/UnExeAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[8631]'));//'取消下达成功！'
                        that.getDetail(that.dataDetail.IPO_code)
                    }
                });

            },
            //确认关闭
            CloseOrder() {
                let that = this;
                this.$confirm(that.$t('getapi[8629]'), that.$t('getapi[194]'), {//'你确认要关闭吗?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                }).then(() => {

                    if (that.$limits.fnIsEmpty(that.dataDetail.Shut_reason)) {
                        that.$message.warning(that.$t('getapi[8630]'));////请填写强制关闭原因
                        return;
                    }
                    let parm = {
                        code: that.dataDetail.IPO_code,
                        ids: "",
                        update_time: that.dataDetail.Modify_Date,
                        LangType: that.$processdata.getLang()
                    }
                    that.btn.confirmclose = false;
                    that.$http.urlpost('/ISS/Order/OkClose', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[4230]'));//关闭成功
                            that.getDetail(that.dataDetail.IPO_code)
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    // type: 'info',
                    // message: '已取消删除'
                    // });
                });


            },
            // 取消审批
            unAudit(){
                let that = this;
                this.$confirm(that.$t('getapi[8751]'), that.$t('getapi[194]'), {//'你确认要取消审批吗?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                }).then(() => {
                    let parm = {
                        code: that.dataDetail.IPO_code,
                        ids: "",
                        update_time: that.dataDetail.Modify_Date
                    }
                    that.btn.assign = false;
                    that.$http.urlpost('/ISS/Order/UnAudit', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8839]'));//'取消审批成功！'
                            that.getDetail(that.dataDetail.IPO_code)
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    // type: 'info',
                    // message: '已取消删除'
                    // });
                });
            },
            //批量设为无效
            setInvalid() {
                let that = this;
                let parm = {
                    Code: '',
                };
                for (let i = 0; i < that.multipleSelection.length; i++) {
                    parm.Code += that.multipleSelection[i].num + ',';

                }
                parm.Code = parm.Code.substring(0, parm.Code.length - 1);
                that.$http.urlpost('/ISS/PQ/UnISSPQ', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                        that.getView();
                        that.getDetail(that.dataDetail.num);//刷右边
                    }
                });
            },
            setClose() {

            },
            setAssign(e) {
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.IPO_code)) {
                    return;
                }

            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ISSProcessOrderViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                //当前是哪个页面就把哪个置为1
                if (this.SelectIndex == 0) {
                    this.pageIndex = 1;
                } else if (this.SelectIndex == 1) {
                    this.pageIndex1 = 1;
                } else if (this.SelectIndex == 2) {
                    this.pageIndex2 = 1;
                } else if (this.SelectIndex == 3) {
                    this.pageIndex3 = 1;
                } else if (this.SelectIndex == 4) {
                    this.pageIndex4 = 1;
                } else if (this.SelectIndex == 5) {
                    this.pageIndex5 = 1;
                } else if (this.SelectIndex == 7) {
                    this.pageIndex7 = 1;
                }
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },

            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/ISS/Order/ISSOrderList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        } else if (that.SelectIndex == 3) {
                            that.dataSet3 = res.DataContent;
                            that.total3 = res.Totals;
                        } else if (that.SelectIndex == 4) {
                            that.dataSet4 = res.DataContent;
                            that.total4 = res.Totals;
                        } else if (that.SelectIndex == 5) {
                            that.dataSet5 = res.DataContent;
                            that.total5 = res.Totals;
                        } else if (that.SelectIndex == 7) {
                            that.dataSet7 = res.DataContent;
                            that.total7 = res.Totals;
                            that.getAuditPerson()
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            getAuditPerson() {
                let that = this
                let parm = {
                    AuditPerson: that.user
                }
                that.$http.urlpost('/ISS/Order/IssOrderListByAuditPerson', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet7_2 = res.DataContent
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if (that.code == row.IPO_code) {
                    return
                }
                that.timeId = setTimeout(() => {
                    if (!this.$limits.menuvisible("plv2", 131, 1)) {
                        return
                    }
                    let datacopy = that.dataDetail
                    for (let i = 0; i < datacopy.DTlines.length; i++) {
                        delete datacopy.DTlines[i]['index']
                    }
                    for(let i = 0;i<datacopy.AuditInfoLists.length;i++){
                        delete datacopy.AuditInfoLists[i]['index']
                    }
                    if (that.oldDataDetail != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.oldSelectIndex = that.activeName
                                that.iscontinuedblclick = true
                                that.code = row.IPO_code
                                that.oldrow = row
                                that.getDetail(row.IPO_code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 3) {
                                    that.$refs.singleTable3.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 4) {
                                    that.$refs.singleTable4.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 5) {
                                    that.$refs.singleTable5.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 7) {
                                    if (that.activeName1 == '7_1') {
                                        that.$refs.singleTable7_1.$refs.singleTable.setCurrentRow(that.oldrow);
                                    } else {
                                        that.$refs.singleTable7_2.$refs.singleTable.setCurrentRow(that.oldrow);
                                    }
                                }
                            });
                    } else {
                        that.oldSelectIndex = that.activeName
                        that.iscontinuedblclick = true
                        that.code = row.IPO_code
                        that.oldrow = row
                        that.getDetail(row.IPO_code);
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.DTlines.length; i++) {
                    delete datacopy.DTlines[i]['index']
                }
                for(let i = 0;i<datacopy.AuditInfoLists.length;i++){
                    delete datacopy.AuditInfoLists[i]['index']
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                that.addoredit = 0
                that.code = ''
                let date = Common.methods.getDate()
                that.dataDetail = {
                    DTlines: [],
                    DTlinesMaterial: [],
                    AuditInfoLists: [],
                    IPO_code: "",
                    IsEdit: 0,
                    huilv: 1,
                    Vender_Code: "",
                    Vender_Name: "",
                    Currency_Code: "CNY",
                    Tax_Rate: 0,
                    Order_Status: 0,
                    Status_Name: "生成",
                    Trans_Type: "",
                    Pay_Cycle: 0,
                    Trans_Charge: 0,
                    Additional_Charge: 0,
                    Pay_Conditions: "",
                    Plan_date: "",
                    Contact_person: "",
                    Transact_person: "",
                    Shut_reason: "",
                    Shut_Person: "",
                    Audit_Person: "",
                    Audit_Date: "",
                    Remark: "",
                    Create_Person: "",
                    Create_Date: "",
                    Modify_Person: "",
                    Modify_Date: "",
                    Vender_Call: "",
                    Vender_Fax: "",
                    Approval_statusName:""
                }
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if(!that.$limits.fnIsEmpty(that.dataDetail.IPO_code)){
                    that.IsEditCode = false;
                    that.dataDetail.IsEdit = 1;
                    that.getDetail(that.dataDetail.IPO_code);
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.DTlines.length; i++) {
                    delete datacopy.DTlines[i]['index']
                }
                for(let i = 0;i<datacopy.AuditInfoLists.length;i++){
                    delete datacopy.AuditInfoLists[i]['index']
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if (!that.$limits.fnIsEmpty(that.dataDetail.IPO_code)) {
                                that.IsEditCode = false;
                                that.dataDetail.IsEdit = 1;
                                that.getDetail(that.dataDetail.IPO_code);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.getView();
                    if (!that.$limits.fnIsEmpty(that.dataDetail.IPO_code)) {
                        that.IsEditCode = false;
                        that.dataDetail.IsEdit = 1;
                        that.getDetail(that.dataDetail.IPO_code);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            selectpeople() {
                let that = this;
                // if (that.$limits.fnIsEmpty(that.dataDetail.Part_Code)) {
                //     that.$message.warning('请选择物料！');
                //     return;
                // }
                // let param = {
                // part_code: that.dataDetail.Part_Code,
                // part_version: that.dataDetail.Part_Name,
                // PUBPart_ID: that.dataDetail.Part_ID
                // }
                that.$refs.people.clearInput(true);
            },
            //工序信息填写
            getPeople(data) {
                let that = this;
                that.dataDetail.Transact_person = data.name;
            },
            //委外选择物料后加入到明细
            getpartt(data) {
                let that = this;
                let obj = {
                    num: 0,
                    Quotation_num: "",
                    Part_ID: that.dataDetail.Part_ID,
                    ListPart_ID: data.exclusively_id,
                    ListPart_routing_ID: 0,
                    ListPart_Cost: data.Column1,
                    ListPart_Qty: data.mount,
                    ListPart_MTL_CODE: data.part_code,
                    ListPart_MTL_NAME: data.part_name,
                    ListPart_MTL_CUR_EDITION: data.part_version,
                    ListPart_RoutingName: "",
                    ListPart_MTL_MASTER_UNIT: data.part_master_unit
                }
                that.dataDetail.Lists.push(obj);
            },
            selectsupplier() {
                let that = this;
                that.$refs.supplier.clearInput(true);
            },
            getsupplier(data) {
                let that = this;
                that.dataDetail.Vender_Code = data.vender_code;
                that.dataDetail.Vender_Name = data.vender_name;
                that.dataDetail.Tax_flag = data.tax_flag;
                that.dataDetail.Currency_Code = data.currency_code;
                if (that.$limits.fnIsEmpty(data.vender_code)) {
                    that.IsEditPrice = false;
                } else {
                    if (that.dataDetail.Tax_Rate != data.tax_rate) {//税率有变化，重新计算
                        //不含税价-->含税价
                        that.dataDetail.Tax_Rate = data.tax_rate;
                        let price = that.dataDetail.Net_unit_price * (1 + that.dataDetail.Tax_Rate / 100);
                        that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
                        that.dataDetail.Unit_Price = price.toFixed(2);
                    } else {
                        that.dataDetail.OldUnitPrice = null;
                    }
                }
                that.IsEditPrice = true;

            },
            CalTaxPrice(e) {
                let that = this;
                that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
                let price = e * (1 + that.dataDetail.Tax_Rate / 100);
                that.dataDetail.Unit_Price = price.toFixed(2);

            },
            handlelistSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.multipleSelection = val;
                that.btnauthority();
            },
            handleSelectionChangeAudit(val) {
                let that = this;
                that.selectDataAudit = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataAudit.push(val[i]);
                }
            },
            delAuditer() {
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let id = ''
                        for (let i = that.selectDataAudit.length - 1; i >= 0; i--) {
                            that.dataDetail.AuditInfoLists.splice(that.selectDataAudit[i].index, 1);
                            if (that.selectDataAudit[i].Exclusively_ID != "") {
                                id = id + that.selectDataAudit[i].Exclusively_ID + ','
                            }
                        }
                        if (id.length > 0) {
                            id = id.substring(0, id.length - 1)
                            let parm = {
                                ids: id
                            }
                            that.$http.urlpost('/ISS/Order/DelISS_Process_Order_AuditInfoByID', parm, function (res) {
                                if (res.Success == 1) {
                                    that.getDetail(that.dataDetail.IPO_code)
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 批量选择
            handleSelectionChangeM(val) {
                //let that = this;
                this.multipleSelectionMain = val;
                if (this.multipleSelectionMain.length > 0) {
                    this.btn.mustclose = true;
                    if (this.dataDetail.Status_Name == '生成') this.btn.deleteline = true;
                    else this.btn.deleteline = false;
                } else {
                    this.btn.mustclose = false;
                    this.btn.deleteline = false;
                }
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNameM({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNameAudit({row, rowIndex}) {
                row.index = rowIndex;
            },
            //删单
            delall() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if (that.$limits.fnIsEmpty(that.dataDetail.IPO_code)) return;
                        let param = {
                            code: that.dataDetail.IPO_code,
                            ids: "",
                            update_time: that.dataDetail.Modify_Date
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/ISS/Order/DelISSOrderByID', param, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.getDetail(that.dataDetail.IPO_code)
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //删行
            delline() {
                let that = this;
                if (that.multipleSelectionMain.length == 0) {
                    return;
                }
                let param = {
                    code: that.dataDetail.IPO_code,
                    ids: "",
                    update_time: that.dataDetail.Modify_Date
                }
                for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                    param.ids = param.ids + that.multipleSelectionMain[i].Exclusively_ID + ',';
                }
                param.ids = param.ids.substring(0, param.ids.length - 1);
                that.btn.deleteline = false;
                that.$http.urlpost('/ISS/Order/DeleteISSPartListByID', param, function (res) {
                    that.btn.deleteline = true;
                    if (res.Success == 1) {
                        for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                            that.dataDetail.DTlines.splice(that.multipleSelectionMain[i].index, 1);
                        }
                        let pricearr = []
                        for (let j = 0; j < that.dataDetail.DTlines.length; j++) {
                            for (let k = 0; k < that.multipleSelectionMain.length; k++) {
                                if (that.multipleSelectionMain[k].Part_Code + that.multipleSelectionMain[k].Part_Version == that.dataDetail.DTlines[j].Part_Code + that.dataDetail.DTlines[j].Part_Version) {
                                    pricearr.push(that.dataDetail.DTlines[j])
                                }
                            }
                        }
                        for (let i = 0; i < pricearr.length; i++) {
                            let qty = 0
                            for (let j = 0; j < that.dataDetail.DTlines.length; j++) {
                                if (pricearr[i].Part_Code + pricearr[i].Part_Version == that.dataDetail.DTlines[j].Part_Code + that.dataDetail.DTlines[j].Part_Version) {
                                    qty = qty + parseFloat(that.dataDetail.DTlines[j].Line_Qty)
                                }
                            }
                            for (let j = 0; j < that.dataDetail.DTlines.length; j++) {
                                if (pricearr[i].Part_Code + pricearr[i].Part_Version == that.dataDetail.DTlines[j].Part_Code + that.dataDetail.DTlines[j].Part_Version) {
                                    let parm = {
                                        Part_ID: that.dataDetail.DTlines[j].Part_ID,
                                        Routing_Version: '',
                                        Vender_Code: that.dataDetail.Vender_Code,
                                        routing_sequence_no: that.dataDetail.DTlines[j].Routing_Sequence_No,
                                        Currency_Code: that.dataDetail.Currency_Code,
                                        qty: qty
                                    }
                                    that.$http.urlpost('/ISS/PQAudit/GetExistIssPartNetPrice', parm, function (res) {
                                        if (res.Success == 1 && res.DataContent.dt1[0].result == 2) {
                                            that.dataDetail.DTlines[j].line_total_unitprice = res.DataContent.Line[0].price
                                            that.dataDetail.DTlines[j].line_net_unitprice = res.DataContent.Line[0].net_price
                                        }
                                        that.caculateTax();
                                    });
                                }
                            }
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.$message.success(that.$t('getapi[659]'));//'删除成功'
                    }
                });
            },
            mustclose() {
                let that = this;
                if (that.multipleSelectionMain.length == 0) {
                    that.$message.warning(that.$t('getapi[8756]'));//"请选择一行数据!"
                    return;
                }
                this.$confirm(that.$t('getapi[8629]'), that.$t('getapi[194]'), {//'你确认要关闭吗?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                }).then(() => {
                    let param = {
                        code: that.dataDetail.IPO_code,
                        ids: "",
                        update_time: that.dataDetail.Modify_Date
                    }
                    for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                        param.ids = param.ids + that.multipleSelectionMain[i].Exclusively_ID + ',';
                    }
                    param.ids = param.ids.substring(0, param.ids.length - 1);
                    param.LangType = that.$processdata.getLang()
                    that.btn.mustclose = false;
                    that.$http.urlpost('/ISS/Order/CloseLines', param, function (res) {
                        that.btn.mustclose = true;
                        if (res.Success == 1) {
                            that.getDetail(that.dataDetail.IPO_code)
                            that.$message.success(that.$t('getapi[4230]'));//关闭成功
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    // type: 'info',
                    // message: '已取消删除'
                    // });
                });


            },
            //导入
            imp() {
                let item = {
                    //label: '外协价表导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/12',
                    url: '/exp/12',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/12'});
                this.$store.commit('selectMenu', item);
            },
            print() {
                //判断状态
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.IPO_code)) {
                    return;
                }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.dloading = true;
                let parm = {
                    po_no: that.dataDetail.IPO_code,
                    HasTaxPrice: that.orderCPrice,
                    TemplateName: '20发外订单.xlsx'
                };
                that.$http.urlpost('/Print/WXPrint', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('print', true);
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.dloading = false;
                });
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Order/ISSOrderExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    that.loading = false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ISSProcessOrderViewInfo",
                    fromname: that.$t('getapi[1039]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;

                let parm = that.dataDetail;
                if (that.$limits.fnIsEmpty(parm.Plan_date)) {
                    that.$message.warning(that.$t('getapi[2736]'));//"计划交期必填！"
                    return;
                }
                if (parm.IsEdit == 0) {//新增
                    //parm.IsEdit = 0;
                    //加属性 Relation_IPO_Code
                    if (!that.$limits.fnIsEmpty(parm.DTlines)) {
                        for (let i = 0; i < parm.DTlines.length; i++) {
                            if (that.$limits.fnIsEmpty(parm.DTlines[i].Plan_Delivery_Date)) {
                                parm.DTlines[i].Plan_Delivery_Date = parm.Plan_date;
                            }
                            if (that.$limits.fnIsEmpty(parm.DTlines[i].Line_Remark)) {
                                parm.DTlines[i].Line_Remark = '';
                            }
                            parm.DTlines[i].Relation_IPO_Code = '';
                            parm.DTlines[i].fa_flag = '';
                            parm.DTlines[i].Exclusively_Id = '';
                            parm.DTlines[i].Line_Status = '0';
                        }
                    }
                }
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/ISS/Order/SaveISSOrder', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[3153]'));//'保存成功'
                        that.dataDetail.IsEdit = 1;
                        that.dataDetail.IPO_code = res.UniqueNum;
                        that.getDetail(that.dataDetail.IPO_code)
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1;
                that.dloading = true;
                that.IsEditPrice = true;
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/ISS/Order/ISSOrderInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        if (that.dataDetail.DTlines == null) {
                            that.dataDetail.DTlines = []
                        }
                        that.dataDetail.IsEdit = 1;
                        that.caculateTax();
                        that.dloading = false;
                        // that.dataDetail.Head.relation_mps_line_id = that.dataDetail.Head.relation_mps_line_id.toString()
                        // that.dataDetail.Head.bom_config_flag = that.dataDetail.Head.bom_config_flag.toString()
                        // that.dataDetail.Head.sr_type_id = that.dataDetail.Head.sr_type_id.toString()
                        // that.SignList = that.dataDetail.SignList
                        console.log('tttttt' + that.dataDetail.AuditInfoLists)
                        if (that.dataDetail.AuditInfoLists != null) {
                            if (that.dataDetail.AuditInfoLists.length > 0) {
                                let flag = 0  // 1:存在驳回
                                for(let i = 0;i<that.dataDetail.AuditInfoLists.length;i++){
                                    if(that.dataDetail.AuditInfoLists[i].Approval_Results == 0){
                                        that.dataDetail.AuditInfoLists[i].isCanAudit = true
                                        flag = 1
                                    } else {
                                        that.dataDetail.AuditInfoLists[i].isCanAudit = false
                                    }
                                }
                                if(flag == 0){
                                    let min = 0
                                    for(let i = 0;i<that.dataDetail.AuditInfoLists.length;i++){
                                        if(that.dataDetail.AuditInfoLists[i].Line_No > min){
                                            min = that.dataDetail.AuditInfoLists[i].Line_No
                                        }
                                    }
                                    for (let i = 0; i < that.dataDetail.AuditInfoLists.length; i++) {
                                        if (that.dataDetail.AuditInfoLists[i].Approval_Results == 2 && that.dataDetail.AuditInfoLists[i].Line_No < min) {
                                            min = that.dataDetail.AuditInfoLists[i].Line_No
                                        }
                                    }
                                    console.log('min' + min)
                                    for (let i = 0; i < that.dataDetail.AuditInfoLists.length; i++) {
                                        if (that.dataDetail.AuditInfoLists[i].Approval_Results == 2 && that.dataDetail.AuditInfoLists[i].Line_No == min) {
                                            that.dataDetail.AuditInfoLists[i].isCanAudit = true
                                        } else {
                                            that.dataDetail.AuditInfoLists[i].isCanAudit = false
                                        }
                                    }
                                }
                            }
                        } else {
                            that.dataDetail.AuditInfoLists = []
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            //计算含税不含税价格
            caculateTax() {
                let that = this;
                let Change_Rate = that.dataDetail.huilv;
                that.orderAPrice = 0;//税
                that.orderBPrice = 0;//不含税
                that.orderCPrice = 0;//含税
                if (that.$limits.fnIsEmpty(that.dataDetail.DTlines)) {
                    return;
                }
                for (let i = 0; i < that.dataDetail.DTlines.length; i++) {
                    let tmqty = 0;//数量
                    let tmpprice = 0;//含税价
                    let tmpTaxPrice = 0;//不含税价
                    let obj = that.dataDetail.DTlines[i];
                    if (!that.$limits.fnIsEmpty(obj.Line_Qty) && !that.$limits.fnIsEmpty(obj.line_total_unitprice) && !that.$limits.fnIsEmpty(obj.line_net_unitprice)) {
                        tmqty = obj.Line_Qty;
                        tmpprice = obj.line_total_unitprice;
                        tmpTaxPrice = obj.line_net_unitprice;
                        that.dataDetail.DTlines[i].line_total_amount = (tmqty * tmpprice).toFixed(4);
                        that.dataDetail.DTlines[i].line_net_amount = (tmqty * tmpTaxPrice).toFixed(4);
                        that.dataDetail.DTlines[i].line_total_amount_cny = (tmqty * tmpprice * Change_Rate).toFixed(4);
                        that.dataDetail.DTlines[i].line_net_amount_cny = (tmqty * tmpTaxPrice * Change_Rate).toFixed(4);

                    }
                    that.orderCPrice += tmqty * tmpprice;
                    that.orderBPrice += tmqty * tmpTaxPrice;

                }
                that.orderAPrice = (that.orderCPrice - that.orderBPrice).toFixed(4);
                that.orderBPrice = that.orderBPrice.toFixed(4);
                that.orderCPrice = that.orderCPrice.toFixed(4);
            },
            handleSelectionChange1(val) {
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val) {
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange3(val) {
                let that = this;
                that.selectData3 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData3.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange4(val) {
                let that = this;
                that.selectData4 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData4.push(val[i]);
                }
                that.btnauthority()
            },
            // 生产业务图
            getPro() {
                let that = this
                let data = {}
                if (that.SelectIndex == 0) {
                    data = that.selectData[0]
                } else if (that.SelectIndex == 1) {
                    data = that.selectData1[0]
                } else if (that.SelectIndex == 2) {
                    data = that.selectData2[0]
                } else if (that.SelectIndex == 4) {
                    data = that.selectData4[0]
                }
                that.$store.commit('setSharedParams',data);
                let item = {
                    label: '生产关系图',
                    name: 'prorelation',
                    path: '/prorelation/sr',
                    url: '/prorelation/sr',
                    icon: 'video-play'
                };
                this.$router.push({path: '/prorelation/sr'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            //批量删除
            batchDel() {
                let that = this
                let arr = []
                if (that.selectData1.length == 0) {
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for (let i = 0; i < that.selectData1.length; i++) {
                    arr = [...arr, {
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRDelLine', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg)
                        that.getView()
                    }
                });
            },
            //批量下达
            batchRelease() {
                let that = this
                let arr = []
                if (that.selectData1.length == 0) {
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for (let i = 0; i < that.selectData1.length; i++) {
                    arr = [...arr, {
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg)
                        that.getView()
                    }
                });
            },
            //撤销下达
            releaseToCreate() {
                let that = this
                let parm = {
                    sr_code: that.selectData2[0].SR_code
                }
                that.$http.urlpost('/Pro/SR/SRReleaseToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg)
                        that.getView()
                    }
                });
            },
            //取消
            batchCancel() {
                let that = this
                let arr = []
                if (that.selectData2.length == 0) {
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for (let i = 0; i < that.selectData2.length; i++) {
                    arr = [...arr, {
                        sr_code: that.selectData2[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRBatchCancel', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg)
                        that.getView()
                    }
                });
            },
            //生成
            cancelToCreate() {
                let that = this
                let parm = {
                    sr_code: that.selectData4[0].SR_code,
                }
                that.$http.urlpost('/Pro/SR/SRCancelToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg)
                        that.getView()
                    }
                });
            },
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            sr_code: that.dataDetail.Head.sr_code,
                            sr_status: that.dataDetail.Head.sr_status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Pro/SR/DelSr', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(res.Msg);
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取物料
            selectpart() {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            //委外获取物料弹窗
            selectpartt() {
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.Part_ID)) {
                    that.$message.warning(this.$t('getapi[8793]'));//'请先选择物料'
                    return;
                }
                let param = {
                    PUBPart_ID: that.dataDetail.Part_ID
                }
                that.$refs.partt.clearInput(true, param);
            },

            getpart(data) {
                let that = this
                console.log(data)
                that.dataDetail.Part_Code = data.part_code;
                that.dataDetail.Part_Name = data.part_name;
                that.dataDetail.InvUnit = data.part_master_unit;
                that.dataDetail.Part_ID = data.exclusively_id;
                //that.getSignList(data.exclusively_id)
            },
            getSignList(id) {
                let that = this
                let parm = {
                    Id: id
                }
                that.$http.urlpost('/Pro/SR/GetSrSignsByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        that.SignList = res.DataContent.DataList
                    }
                });
            },
            selectitem() {
                let that = this;
                that.$refs.item.clearInput(true);
            },
            getitem(data) {
                let that = this
                console.log(data)
                that.dataDetail.Head.item_code = data.item_code
            },
            // 外协订单明细排序
            sortChange(column) {
                let that = this
                let name = column.prop
                if (column.order == "ascending") {
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.DTlines.indexOf(obj1) - that.dataDetail.DTlines.indexOf(obj2);
                        }
                    }
                    that.dataDetail.DTlines = that.dataDetail.DTlines.sort(compare);
                } else if (column.order == "descending") {
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.DTlines.indexOf(obj2) - that.dataDetail.DTlines.indexOf(obj1);
                        }
                    }
                    that.dataDetail.DTlines = that.dataDetail.DTlines.sort(compare);
                }
            },
            // 计算批量价
            detailSum(row) {
                let that = this;
                if (that.timeId) {
                    clearTimeout(that.timeId)
                }
                that.timeId = setTimeout(() => {
                    let index = row.$index;
                    let qty = 0
                    for (let i = 0; i < that.dataDetail.DTlines.length; i++) {
                        if (that.dataDetail.DTlines[i].Part_Code + that.dataDetail.DTlines[i].Part_Version == row.row.Part_Code + row.row.Part_Version) {
                            qty = qty + parseFloat(that.dataDetail.DTlines[i].Line_Qty)
                        }
                    }
                    let parm = {
                        Part_ID: row.row.Part_ID,
                        Routing_Version: '',
                        Vender_Code: that.dataDetail.Vender_Code,
                        routing_sequence_no: row.row.Routing_Sequence_No,
                        Currency_Code: that.dataDetail.Currency_Code,
                        qty: qty
                    }
                    that.$http.urlpost('/ISS/PQAudit/GetExistIssPartNetPrice', parm, function (res) {
                        if (res.Success == 1 && res.DataContent.dt1[0].result == 2) {
                            for (let i = 0; i < that.dataDetail.DTlines.length; i++) {
                                if (that.dataDetail.DTlines[i].Part_Code + that.dataDetail.DTlines[i].Part_Version == row.row.Part_Code + row.row.Part_Version) {
                                    that.dataDetail.DTlines[i].line_total_unitprice = res.DataContent.Line[0].price
                                    that.dataDetail.DTlines[i].line_net_unitprice = res.DataContent.Line[0].net_price
                                }
                            }
                        }
                        that.caculateTax();
                        that.$refs.SetBtn.SetOneBtnEnable('save', true)
                        clearTimeout(that.timeId)
                    });
                }, 500);
            },
            selectAuditer() {
                let that = this;
                that.$refs.auditer.clearInput(true, true, 2);
            },
            getAuditer(data) {
                let that = this;
                console.log(data);
                if (that.dataDetail.AuditInfoLists.length > 0) {
                    data = data.filter(item => {
                        return that.dataDetail.AuditInfoLists.every(item2 => {
                            return item2.userID != item.code
                        })
                    })
                }
                for (let i = 0; i < data.length; i++) {
                    that.dataDetail.AuditInfoLists = [
                        ...that.dataDetail.AuditInfoLists,
                        {
                            Exclusively_ID: '',
                            Relation_IPO_code: that.dataDetail.IPO_code,
                            Relation_Rule_NO: '',
                            Line_No: '',
                            userID: data[i].code,
                            Post_Name: data[i].post,
                            AuditPerson: data[i].name,
                            loginName: data[i].loginname,
                            Approval_Results: 2,
                        }
                    ];
                }
            },
            addAuditer(row) {
                let that = this
                let parm = {
                    "Exclusively_Id": row.Exclusively_ID,
                    "Relation_IPO_code": row.Relation_IPO_code,
                    "Relation_Rule_NO": row.Relation_Rule_NO,
                    "Relation_Exclusively_Id": 0,
                    "Line_No": row.Line_No,
                    "AuditPerson": row.AuditPerson,
                    "userID": row.userID,
                    "loginName": row.loginName,
                    "Department_Name": row.Department_Name,
                    "Post_Name": row.Post_Name,
                    "Create_person": row.Create_person,
                    "Create_time": row.Create_time,
                    "Approval_Results": row.Approval_Results,
                    "Approval_Opinion": row.Approval_Opinion,
                    "Modify_person": row.Modify_person,
                    "Modify_time": row.Modify_time
                }
                that.$http.urlpost('/ISS/Order/AddISSProcessOrderAuditInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.getDetail(that.dataDetail.IPO_code)
                    }
                });
            },
            sign(row) {
                let that = this;
                that.reason = '';
                that.selectSignData = row;
                that.signVisiable = true;
            },
            confirmSign(type) {
                let that = this;
                let datetime = Common.methods.getDatetime();
                let row = that.selectSignData;
                let parm = {
                    ipo_code: that.dataDetail.IPO_code,
                    modify_time: that.dataDetail.Modify_Date,
                    Approval: {
                        Exclusively_ID: row.Exclusively_ID,
                        Relation_IPO_code: row.Relation_IPO_code,
                        Relation_Rule_NO: row.Relation_Rule_NO,
                        Relation_Exclusively_Id: row.Relation_Exclusively_Id,
                        Line_No: row.Line_No,
                        AuditPerson: row.AuditPerson,
                        userID: row.userID,
                        loginName: row.loginName,
                        Department_Name: row.Department_Name,
                        Post_Name: row.Post_Name,
                        Create_person: row.Create_person,
                        Create_time: row.Create_time,
                        Approval_Results: type,
                        Approval_Opinion: that.reason,
                        Modify_person: row.Modify_person,
                        Modify_time: datetime
                    },
                    LangType: that.$processdata.getLang()
                };
                that.$http.urlpost('/ISS/Order/ISSOrderSign', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg);
                        that.getDetail(that.dataDetail.IPO_code)
                        that.signVisiable = false;
                    }
                });
            },
            // 批量审核
            batchAudit(){
                let that = this
                that.reason = '';
                that.signVisiableBatch = true;
            },
            confirmBatchAudit(type){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        code: that.selectData[i].IPO_code,
                        modify_time: that.selectData[i].Modify_Time
                    }]
                }
                let parm = {
                    list: arr,
                    approval_results: type,
                    approval_opinion: that.reason
                }
                that.$http.urlpost('/ISS/Order/UpdateApprovalBatch', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg)
                        that.signVisiableBatch = false
                        that.getView()
                    }
                });
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[1488]')//'下达';
                } else if (val == 2) {
                    return that.$t('getapi[1621]')//'部分到达';
                } else if (val == 3) {
                    return that.$t('getapi[1622]')//'到达';
                } else if (val == 5) {
                    return that.$t('getapi[441]')//'关闭';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[5165]')//'常规';
                } else if (val == 1) {
                    return that.$t('getapi[6094]')//'审批中';
                } else if (val == 2) {
                    return that.$t('getapi[6188]')//'不同意';
                } else if (val == 3) {
                    return that.$t('getapi[6187]')//'同意';
                } else {
                    return '';
                }
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 131,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.DTlines.length; i++) {
                    delete datacopy.DTlines[i]['index']
                }
                for(let i = 0;i<datacopy.AuditInfoLists.length;i++){
                    delete datacopy.AuditInfoLists[i]['index']
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        overflow-x: auto;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 10px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 0px;
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .red {
        background: #ff7879;
    }
</style>
